import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/lib/auth";
import { PageHeader } from "@/components/app/PageHeader";
import { ChangelogPanel } from "@/components/app/ChangelogPanel";
import { ApkReleasesPanel } from "@/components/app/ApkReleasesPanel";

export default function UpdatesPage() {
  const { user } = useAuth();
  const isSuper = !!user && user.role === "super_admin";
  return (
    <div>
      <PageHeader eyebrow="Plateforme" title="Mises à jour" description={isSuper ? "Publiez les nouveautés du portail et envoyez les nouvelles versions de l'application aux télés." : "Les dernières nouveautés d'Innova-Sign Cloud."} />
      {isSuper ? (
        <Tabs defaultValue="changelog">
          <TabsList className="mb-6 border border-slate-800 bg-slate-900">
            <TabsTrigger value="changelog" data-testid="tab-changelog">Nouveautés</TabsTrigger>
            <TabsTrigger value="apk" data-testid="tab-apk">Application TV (APK)</TabsTrigger>
          </TabsList>
          <TabsContent value="changelog"><ChangelogPanel /></TabsContent>
          <TabsContent value="apk"><ApkReleasesPanel /></TabsContent>
        </Tabs>
      ) : <ChangelogPanel />}
    </div>
  );
}
